import { motion } from "framer-motion";
import { EASE } from "@/lib/motion";

const line = {
  hidden: { y: "110%" },
  show: { y: "0%", transition: { duration: 1.15, ease: EASE } },
};

export const MaskedLines = ({ lines, delay = 0, onLoad = false, className = "" }) => {
  const parent = { hidden: {}, show: { transition: { staggerChildren: 0.11, delayChildren: delay } } };
  const trigger = onLoad ? { animate: "show" } : { whileInView: "show", viewport: { once: true, amount: 0.1 } };
  return (
    <motion.span className={`block ${className}`} variants={parent} initial="hidden" {...trigger}>
      {lines.map((content, i) => (
        <span key={i} className="-mb-[0.14em] block overflow-hidden pb-[0.14em]">
          <motion.span className="block" variants={line}>
            {content}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};
